module.exports = __webpack_public_path__ + "img/download.36cb5bac.svg";